<eaglei-leaflet-layer-header [layer]="this" (activeToggled)="toggleLayer($event)" [hideLegend]="true"></eaglei-leaflet-layer-header>

@if (isActive) {

<form [formGroup]="eventSelectionForm">
    <mat-form-field>
        <mat-label>Event</mat-label>
        <mat-select formControlName="event">
            <mat-option>None</mat-option>

            @for (entry of mapsterEvents | keyvalue; track entry.key) {
            <mat-optgroup [label]="entry.key | titlecase">
                @for (event of entry.value; track event.id) {
                <mat-option [value]="event.id">{{ event.name }}</mat-option>
                }
            </mat-optgroup>
            }
        </mat-select>
    </mat-form-field>
</form>

<div #legendElement>
    <div class="status-legend dot-legend">
        <div>
            <div class="circle-container">
                <div class="circle mapster"></div>
                <span class="label"> Mapster Imagery Location</span>
            </div>
        </div>
    </div>
</div>
}
